
export default function compressMatrix(matrix) {
  if (!Array.isArray(matrix))
    throw 'Must pass a matrix'

  const map = {}
  const values = []
  const cutt = matrix[0].length
  let nextCode = 0
  let currentCode = nextCode

  let characters = 0

  for (let i = 0; i < matrix.length; i++) {
    for (let j = 0; j < matrix[i].length; j++) {
      const value = matrix[i][j]
      characters += value.length
      if (map[value]) {
        currentCode = map[value]
      } else {
        currentCode = nextCode++
        map[value] = currentCode
      }
      values.push(currentCode)
    }
  }

  let newMap = ''
  let list = []
  Object.entries(map).forEach(([key, value]) => list.push([value, key]))
  list.sort((a, b) => a[0] - b[0]).forEach(line => newMap += `${line[1]};`)
  newMap = newMap.slice(0, -1)

  return { map: newMap, values: values.join(';'), cutt, e: ((newMap.length + values.length) / characters) }
}
